import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  iconfont: 'md',
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#6a11cb',
        secondary: '#2575fc',
        accent: '#8c54ff',
        error: '#f44336',
        info: '#2196f3',
        success: '#0CCE6B',
        warning: '#ff9800',
        background: '#f8fafc',
      },
      dark: {
        primary: '#8c54ff',
        secondary: '#4a97ff',
        accent: '#a77bff',
        error: '#ff5252',
        info: '#4db6ff',
        success: '#4aea8f',
        warning: '#ffb342',
        background: '#121212',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
